/**
 * Save scroll position
 * **/
function bpDispatchScrollPosChanged(){
    localStorage.scrollTop = $('#search-results-list').scrollTop();
}

window.bpDispatchScrollPosChanged = bpDispatchScrollPosChanged;
